import React, { useState, useEffect } from "react";
import { generateHeader } from "../../utils/paso2.utils";
import { SUCURSALES, CURSOS_INGLES } from "../../utils/constants";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Card = ({ data, state, handleClick, textoBoton, id, value, setCursos, send,  contador, setContador }) => {
  console.log('context seleccionados', state.context.seleccionados)
  const [indiceXSubmenu, setIndiceXSubmenu] = useState(0);
  const [indiceYSubmenu, setIndiceYSubmenu] = useState(0);
  

  const generateKey = () => {
      // return Math.random().toString(30).substring(2);
      setContador(() => contador + 1)
      return contador
  }



  const handleCupon = (curso) => {
    if(!curso?.precioAnterior){
      let copiaCurso = curso;
      const descuento = curso.Cupones.reduce((total, cupon) => 
      total + cupon.ValorCupon
    , 0)
    const precioAnterior = copiaCurso.Valor
    copiaCurso.Valor = (precioAnterior - descuento)
    copiaCurso.precioAnterior = precioAnterior
    return copiaCurso
   }
  } 


  const handleCheck = (e, el, index, element, idx, indexp) => {
    console.log('VER: ', e, el, index, element, idx, indexp)
    let cursos = [] 
     const CargosPagado = element.Cargos.filter(cargo => cargo.Cargo !== el.Cargo)
     CargosPagado.forEach(element => {
     // element.Pagar = 1
     });
    
    let dataCopy = [...data]
     

     const sortIndex = generateKey()
     let key = dataCopy[idx]["Horarios"][indexp]["IdHorario"]

    // si true incremento, else , decremento (que tome del actual a los proximos)
    const header = generateHeader(dataCopy, idx, key)

    if(e.target.checked){
      const imagen = dataCopy[idx]['Imagen']
      
      for (let ix = 0; ix <= element.Cargos.length -1 ; ix++) {
        
       
        if(ix === 0){
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]["Header"] = header  // al tenerlo en seleccionados, no se pueden adjuntar, por tenerlos ya, agarralos desde la api
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]["Header"]["IdSede"] = state.context.sede // segun la sede que tenga en el momento se va al header
        }else{}
        
        dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]["Key"] = key
        dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IndexCurso = idx
        dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IndexHorario = indexp
        dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IndexCargo = index
        dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IdHorario = key
        dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].sortIndex = sortIndex
        dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IdSede =  state.context.sede
        
        if(ix < index){
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Pagar =  1
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Seleccionado = true //e.target.checked
        }
        if(ix === index){
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Pagar =  1
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Seleccionado = true //e.target.checked
        }
        if(ix > index){
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Pagar =  0
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Seleccionado = false //e.target.checked
        }          
        if (!dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]?.precioAnterior) {
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Descuento = dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Cupones?.filter(element => element.Aplicar).reduce((prev, next) => prev + next.ValorCupon, 0)
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]["precioAnterior"] = dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Valor
          dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Valor             = dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].precioAnterior - dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Descuento
        }
      }
      
    state.context.seleccionados.forEach(e => cursos.push(e))
    console.log(cursos)
    dataCopy[idx]['Horarios'][indexp]["Cargos"].forEach(e => {
      // si no existe, ponerlo
         let objeto = cursos.find((f) => (f.IdCargo + f.Orden === e.IdCargo + e.Orden) &&  f.De === e.de)
         if(objeto){
             if(!objeto.Cobrado){
               cursos = cursos.filter(cargo => cargo.IdCargo + cargo.Orden !== e.IdCargo + e.Orden)
               console.log(e.Pagado)
               e.Imagen=imagen
               cursos.push(e)  
             }
         }else{
           e.Imagen=imagen
           cursos.push(e)
   
         }
    })
    const filtrados = new Set([...cursos])
   console.log('cursos:', cursos)
    //const filtrados = [...cursos]
    console.log(filtrados)
    const filtradosArr = [...filtrados]
      send("SELECCIONAR", {seleccionado:  filtradosArr}) 
      setCursos(()=> dataCopy)
    }else{
      // codigo para edicion con el indice del seleccionado
      let seleccionados = state.context.seleccionados
      //console.log('seleccionadosseleccionados', seleccionados)
      let seleccionado = dataCopy[idx]["Horarios"][indexp]["Cargos"][index]
      let cargosLength = dataCopy[idx]["Horarios"][indexp]["Cargos"].length
      for (index; index < cargosLength ; index++) {
        dataCopy[idx]["Horarios"][indexp]["Cargos"][index]['Pagar'] = 0
        dataCopy[idx]["Horarios"][indexp]["Cargos"][index]['Seleccionado'] = false
      }
      seleccionados = seleccionados.map(cargo => {
        if((cargo.Key + cargo.IdCargo + cargo.De) === (seleccionado.Key + seleccionado.IdCargo + seleccionado.De)){
          cargo.Pagar = 0;
          cargo.Cobrado = false;
          seleccionado.Seleccionado = false;
          seleccionado.Pagar = 0;
        }else{

        }
        return cargo
      })
      
      let idCargo = seleccionado.IdCargo;
      let cargosSeleccionado = seleccionados.filter( cargo => cargo.IdCargo == idCargo)
      //console.log('cargosSeleccionado::', cargosSeleccionado)
      if(cargosSeleccionado.every(cargo => !cargo.Seleccionado)){
        seleccionados = seleccionados.filter( cargo => cargo.IdCargo !== idCargo)
        //console.log('SELECCIONADOS AHORA:', seleccionados) 
        send("QUITAR_DE_RESUMEN", {seleccionado: seleccionados})
      }else{
        send("QUITAR_DE_RESUMEN", {seleccionado: seleccionados})
      }
       send("QUITAR_DE_RESUMEN", {seleccionados: seleccionados})
    }
  }

  

  const handleButtonClick = (e, idxPadre, idxHijo) => {

    const IdSede =  state.context.sede;
    if(e.target.localName === "p"){
     
    }else{
      setIndiceXSubmenu(() => idxPadre);
      setIndiceYSubmenu(() => idxHijo);
      const cursosCopy = [...data];
      cursosCopy[idxPadre]["Horarios"][idxHijo]["Cargos"].forEach(
        cargo => {
          cargo.IdSede = IdSede
        }
      );
      const claveFiltro = cursosCopy[idxPadre]["Horarios"][idxHijo]["IdHorario"]

      const filtrados = state.context.seleccionados.filter(el => el.IdHorario === claveFiltro)
      
      cursosCopy[idxPadre]["Horarios"][idxHijo]["Cargos"].forEach(
        cargo => {
          filtrados.forEach(filtrado => {
            if(filtrado.Orden === cargo.Orden){
                 if( filtrado.Key === cargo.Key && filtrado.IdSede === parseInt(cargo.IdSede) ){ // IdSede nuevo para que no seleccione todas las sedes que coinciden
                  
                   cargo.Seleccionado = filtrado.Cobrado?true:filtrado.Seleccionado  // tenia Seleccionado
                   cargo.Cobrado = filtrado.Cobrado // line mala
                 }
            }
          })
        }
      )
      setCursos(cursosCopy)
      if (cursosCopy[idxPadre].Horarios[idxHijo].show) {
        if(e.target.type === undefined){
          cursosCopy[idxPadre].Horarios[idxHijo].show = false;
        }
      } else {
        if(e.target.type === undefined){
          cursosCopy.forEach((element, index) => {
              element.Horarios.forEach((horario, index) => {
                horario.show = false;
              });
          });
        }
        cursosCopy[idxPadre].Horarios[idxHijo].show = true;
        cursosCopy[idxPadre].Horarios[idxHijo].Cargos[0].DescripcionPlan = cursosCopy[idxPadre].Horarios[0].DescripcionPlan;
      }
      setCursos(cursosCopy);
    }
  };
  
useEffect(() => {
  
console.log('cambios en la data...')
  
}, [data])

  return (
    <div className={"bg-primarioMira rounded-md p-1 m-2 content-center w-full"}>

      <div className={"flex content-center "}>
        {data.length > 0 && (
          <>
          <p className={"text-white mx-auto font-medium text-2xl mt-2"}>
            {`Cursos disponibles en sede ${SUCURSALES[state.context.sede]}`}
          </p>
          <p className="ml-4 text-secundario">Seleccione el horario resaltado en azul y, a continuación, marque las casillas correspondientes a los cursos que desea añadir.</p>
          </>
        )}
      </div>
      {data.length > 0 ? (
        <div
          role="list"
          className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-2 xl:grid-cols-3 mx-3 mb-4"
        >
          {data.map((project, idx) => (
            <div className={`max-w-sm p-2 border border-gray-200 bg-secundarioMira rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 animation-expand elementFadeIn `}>
              {project.IdCurso > 9 && project.IdCurso < 23?
              <div className="text-center m-1 p-2">
                <p className={`/inline text-white bg-${CURSOS_INGLES[project.IdCurso]['color']} m-auto rounded-full w-30 h-30 ring-1 ring-white text-5xl`}>
                {CURSOS_INGLES[project.IdCurso]['inicial']}
                </p>
              </div>
              :
              <img
                width="96"
                height="96"
                src={(`./img/cursos/${project?.Imagen}`)}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src='./img/cursos/defaultImage.jpg';
                }}
                className="/h-12 /w-12 mx-auto">
              </img>
            }
              <a href="#" className="mx-auto inline text-center">
                <p className="mb-2 text-xl font-medium tracking-tight text-white dark:text-white ">
                  {project[value]}
                </p>
              </a>
              <p className="mb-3 font-normal text-gray-400">{project?.Dias}</p>

              {project.Horarios.map((element, indexp) => (
                <div
                  onClick={(e) => handleButtonClick(e, idx, indexp)}
                  className="shadow-azulBrillanteMira shadow-sm rounded-md  my-2"
                >
                  <div className="flex flex-row w-full bg-azulBrillanteMira rounded-t-md rounded-b-md">
                    <div className="flex justify-between w-full">
                      <button
                        id="dropdownDefaultButton"
                        data-dropdown-toggle="dropdown"
                        className="text-white bg-azulBrillanteMira font-medium rounded-lg text-sm px-4 py-1 text-center flex items-center"
                        type="button"
                      >
                        <div className="flex flex-col justify-items-start">
                          <span className="flex">{element.NombrePlan}</span>
                          <span className="flex text-xs">
                            {element.DescripcionPlan}
                          </span>
                        </div>
                      </button>
                      <svg
                        className="w-2.5 h-2.5 ms-3 flex text-white m-4"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 10 6"
                      >
                        <path
                          className="flex"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeWidth="2"
                          d="m1 1 4 4 4-4"
                        />
                      </svg>
                    </div>
                  </div>

                  {element?.show && (
                    <div
                      id="dropdown"
                      className={
                        "z-10 bg-primarioMira divide-y divide-gray-100 rounded-b-md shadow w-full dark:bg-gray-700 mb-2"
                      }
                    >
                      <ul
                        className="py-2 text-sm text-white dark:text-gray-200"
                        aria-labelledby="dropdownDefaultButton"
                      >
                        {element.Cargos.map((el, index) => (
                          <li>
                            <div className={el.Seleccionado? "flex flex-row bg-secundarioMira":  "flex flex-row"}>
                              <div className="flex w-3/4 flex-col cursor-default">
                                <a
                                  href="#"
                                  className="block px-2 /py-2 |hover:bg-primarioMira  font-medium cursor-default"
                                >
                                  {el.Cargo}{" "}
                                  
                                </a>
                                <div className="flex flex-row |hover:bg-secundarioMira cursor-default">
                                  <a
                                    href="#"
                                    className="block px-4 py-1 text-xs cursor-default"
                                  >
                                    Inicio {el.De}
                                  </a>
                                  <a
                                    href="#"
                                    className="block px-4 py-1 text-xs cursor-default"
                                  >
                                    Fin {el.A}
                                  </a>
                                </div>
                                
                              </div>
                              
                              <div className="flex w-1/4 flex-col cursor-default ">
                              <p
                              name="precio"
                                className="mx-auto text-secundario inline ">
                                    Q. {el.Valor}.00
                                  </p>
                                {/*
                                */}
                                <input
                                  type="checkbox"
                                  className={classNames(el.Cobrado === true ?"text-grisMira":"text-azulBrillanteMira", "m-auto  w-6 h-6 rounded-md cursor-pointer hover:shadow-sm hover:shadow-white")}
                                  checked={el?.Seleccionado}
                                  disabled={el?.Cobrado}
                                  onChange={(e) => handleCheck(e, el, index, element, idx, indexp )}
                                ></input>
                                
                              </div>
                            </div>
                            <hr className="w-[95%] mx-auto opacity-50"></hr>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}

            </div>
          ))}
        </div>
      ) : (
        <div className="text-2xl text-secundario flex w-full">
          <p className="flex m-auto">No se encontraron cursos disponibles</p>
        </div>
      )}
    </div>
  );
};

export default Card;
